<template>
  <div class="main-container d-flex flex-wrap" style="text-align: -webkit-center;">
    <div class="col-lg-12 col-md-12">
      <FilterManager
          ref="filterManager"
          :config="config"
          @resetPage="resetPage"
          @refresh="refresh"/>
    </div>
    <div class="col-lg-12 col-md-12">
      <div class="applications__grid" style="margin: 0px;" v-if="!status.get && products && products.length > 0">
        <div class="applications__childs p-0" v-for="(product, index) in products" :key="index">
          <div class="d-flex flex-column" style="height:100%;">
            <a :href="`/productos/${product.slug}`" style=" padding: 10px;">
              <div class="slide-img p-2">
                <img v-if="product.asset && product.asset.slug" :src="`/api/public/v1/assets/${product.asset.slug}`"
                     class="img-fluid">
                <div class="overlay d-flex">
                  <a :href="`/productos/${product.slug}`" class="main-button small px-2" style="min-width: auto;">Ver
                    producto</a>
                </div>
              </div>
            </a>
            <div class="detail-box" style="padding: 10px; border-top: 1px solid #c1c1c1;">
              <div class="type col-md-12">
                <label class="col-md-12">
                  <a class="text-dark text-center" :href="`/productos/${product.slug}`"
                     style="font-size: 15px;
                                    color: var(--gray-deep__to__gray-light);
                                    overflow-wrap: break-word;display: -webkit-box;
                                    -webkit-line-clamp: 2;-webkit-box-pack: center;-webkit-box-orient:
                                    vertical;overflow: hidden;text-overflow: ellipsis;
                                    "
                  >{{ product.name }}</a>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="status.get" class="h-977">
        <div class="spinner-border spinner-border-sm spinner-margin" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="row h-977" v-else>
        <div class="col-md-12 text-align-last-center">
          No se han encontrado productos
        </div>
      </div>
      <div class="col-12 my-5" v-if="!status.get">
        <button class="btn btn-light m-2" @click.prevent="pageFilter -= 1" v-if="pageFilter >= 1"><i
            class="fas fa-chevron-left"></i></button>
        <template v-for="(page, index) in pages">
          <button
              v-if="Math.abs(page - pageFilter) <= 1 || (pageFilter == 0 && Math.abs(page - pageFilter) < 3) || (page == 3 && pageFilter < 3)"
              :key="index"
              class="btn btn-light m-2"
              @click.prevent="pageFilter = (page - 1)"
              :class="{
                            active: (pageFilter + 1) === page, 
                            last: (page == pages - 1 && Math.abs(page - pageFilter) >= 3), 
                            first:(page == 0 && Math.abs(page - pageFilter) >= 3)
                        }">
            {{ page }}
          </button>
        </template>
        <button class="btn btn-light m-2" @click.prevent="pageFilter += 1" v-if="pageFilter < ( pages - 1 )"><i
            class="fas fa-chevron-right"></i></button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import Moment from 'moment';
import FilterManager from './components/FilterManager.vue';

export default {
  components: {
    FilterManager
  },
  data() {
    return {
      products: null,
      metadata: null,
      status: {
        get: true
      },
      config: {
        colors: null,
        categories: null,
        brands: null
      },
      pageFilter: 0
    }
  },
  // mounted() {
  //     this.getConfigVariables();
  // },
  computed: {
    pages: function () {
      return this.metadata && this.$refs.filterManager ? Math.ceil(this.metadata.total / this.$refs.filterManager.filters.page_size) : 0;
    }
  },
  watch: {
    pageFilter: {
      handler: function (newItem) {
        if (this.metadata) {
          this.$refs.filterManager.refresh();
        }
      },
      immediate: true
    }
  },
  methods: {
    refresh(filters) {
      this.status.get = true;

      let searchFilter = !!filters.search_filter ? `&search_filter=${filters.search_filter}` : '';
      let categoriesFilter = filters.category_ids ? `&category_ids=${filters.category_ids}` : '';
      let isosFilter = !!filters.isos ? `&isos=${filters.isos}` : '';
      let basesFilter = !!filters.bases ? `&bases=${filters.bases}` : '';
      let brandFilter = !!filters.brand ? `&brand=${filters.brand}` : '';

      let params = searchFilter + brandFilter + categoriesFilter + isosFilter + basesFilter;

      axios.get(`/api/public/v1/products?pageSize=${filters.page_size}&page=${this.pageFilter + 1}${params}`, {
        headers: {
          "x-api-key": "NPP3dB1ch8CiEmRGprtB2Vpr7xbZdA7iUnw7gX7ORjXdX0vzQ"
        }
      }).then(response => {
        this.products = response.data.data;
        this.metadata = response.data.meta;
      }).catch((e) => {
        this.$awn.warning('No se han podido obtener los productos');
      }).finally(() => {
        this.status.get = false;
      });
    },
    // getConfigVariables() {
    //     axios.get(`/api/public/v1/products/support-data`, {
    //         headers: {
    //             "x-api-key": "NPP3dB1ch8CiEmRGprtB2Vpr7xbZdA7iUnw7gX7ORjXdX0vzQ"
    //         }
    //     }).then(response => {
    //         this.config.isos = response.data.data.isos;
    //         this.config.bases = response.data.data.bases;
    //         this.config.colors = response.data.data.colors;
    //     });
    //
    //     axios.get(`/api/public/v1/categories`, {
    //         headers: {
    //             "x-api-key": "NPP3dB1ch8CiEmRGprtB2Vpr7xbZdA7iUnw7gX7ORjXdX0vzQ"
    //         }
    //     }).then(response => {
    //       this.config.categories = response.data.data;
    //     });
    //
    //
    //     axios.get(`/api/public/v1/brands?pageSize=100`, {
    //         headers: {
    //             "x-api-key": "NPP3dB1ch8CiEmRGprtB2Vpr7xbZdA7iUnw7gX7ORjXdX0vzQ"
    //         }
    //     }).then(response => {
    //         this.config.brands = response.data.data;
    //     });
    // },
    formatDate(date) {
      return Moment.utc(date).format('DD/MM/YYYY');
    },
    changePage(number) {
      if (number >= 0 && number < this.pages) {
        this.pageFilter = number;
      }
    },
    setPage(page) {
      switch (page) {
        case 1:
          //this.buttonActivated = page; son 4 paginas
          return this.pageFilter + 1;
        case 2:
          //this.buttonActivated = page;
          return this.pageFilter + 2;
        case 3:
          //this.buttonActivated = page;
          return this.pageFilter + 3;
        default:
          return 0;
      }
    },
    resetPage() {
      this.pageFilter = 0;
    },
  }
}
</script>
<style lang="scss" scoped>
.green {
  color: green;
}

.red {
  color: red;
}

.spinner-margin {
  width: 5rem;
  height: 5rem;
}

.h-977 {
  min-height: 500px;
}

.text-align-last-center {
  text-align-last: center;
}

.icon-sad {
  font-size: 150px;
}

.text-left-line {
  border-left: solid grey 1px;
}

.active {
  color: #ffffff !important;
  background-color: #007bff !important;
  border-color: #007bff !important;
}

.applications__grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  @media (max-width: 1200px) {
  }
}

.applications__childs {
  min-width: 250px;
  max-width: 280px;
  flex: 1;
  border: 1px solid #c1c1c1;
  padding: 10px;
  border-radius: 5px;
}
</style>